import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { business, navLinks, serviceDetails } from "../data/jalRoData";
import { EnquiryPopup } from "./JalRoForms";

export const SectionTitle = ({ eyebrow, title, text, light = false }) => (
  <div className={`jal-section-title ${light ? "text-white" : ""}`}>
    {eyebrow && <span>{eyebrow}</span>}
    <h2>{title}</h2>
    {text && <p>{text}</p>}
  </div>
);

const Header = () => {
  const [open, setOpen] = useState(false);
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    const onScroll = () => setSticky(window.scrollY > 80);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setOpen(false);

  return (
    <header className={`jal-header ${sticky ? "is-sticky" : ""}`}>
      <div className="jal-topbar">
        <div className="container">
          <div className="jal-topbar-inner">
            <a href={business.phoneHref}>
              <i className="fas fa-phone-alt" /> {business.phone}
            </a>
            <a href={business.emailHref}>
              <i className="fas fa-envelope" /> {business.email}
            </a>
            <span>
              <i className="fas fa-map-marker-alt" /> {business.address}
            </span>
          </div>
        </div>
      </div>
      <div className="jal-navbar">
        <div className="container">
          <div className="jal-navbar-inner">
            <Link className="jal-logo" to="/" onClick={closeMenu}>
              <img src={business.logo} alt="Jal RO System" />
            </Link>
            <nav className={`jal-nav ${open ? "is-open" : ""}`}>
              {navLinks.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={closeMenu}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
            <div className="jal-header-actions">
              <a className="jal-call-btn" href={business.phoneHref}>
                <i className="fas fa-phone-alt" /> Call Now
              </a>
              <button
                className="jal-menu-toggle"
                type="button"
                onClick={() => setOpen((value) => !value)}
                aria-label="Toggle menu"
              >
                <i className={`fas ${open ? "fa-times" : "fa-bars"}`} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

const Footer = () => (
  <footer className="jal-footer">
    <div className="container">
      <div className="row gy-4">
        <div className="col-lg-4 col-md-6">
          <Link className="jal-logo jal-footer-logo" to="/">
            <img src={business.logo} alt="Jal RO System" />
          </Link>
          <p>
            Professional RO water purifier installation, repair, AMC,
            maintenance, and commercial RO plant service across Delhi NCR.
          </p>
          <a className="jal-whatsapp-btn" href={business.whatsapp}>
            <i className="fab fa-whatsapp" /> WhatsApp Us
          </a>
        </div>
        <div className="col-lg-2 col-md-6">
          <h3>Quick Links</h3>
          <ul>
            {navLinks.map((item) => (
              <li key={item.path}>
                <Link to={item.path}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-lg-3 col-md-6">
          <h3>Services</h3>
          <ul>
            {serviceDetails.slice(0, 7).map((item) => (
              <li key={item.slug}>
                <Link to={`/services/${item.slug}`}>{item.shortTitle}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-lg-3 col-md-6">
          <h3>Contact Details</h3>
          <ul className="jal-contact-list">
            <li>
              <i className="fas fa-phone-alt" />
              <a href={business.phoneHref}>{business.phone}</a>
            </li>
            <li>
              <i className="fas fa-envelope" />
              <a href={business.emailHref}>{business.email}</a>
            </li>
            <li>
              <i className="fas fa-map-marker-alt" />
              <span>{business.address}</span>
            </li>
          </ul>
          <div className="jal-socials">
            <a href="https://www.facebook.com/" aria-label="Facebook">
              <i className="fab fa-facebook-f" />
            </a>
            <a href="https://www.instagram.com/" aria-label="Instagram">
              <i className="fab fa-instagram" />
            </a>
            <a href="https://www.linkedin.com/" aria-label="LinkedIn">
              <i className="fab fa-linkedin-in" />
            </a>
          </div>
        </div>
      </div>
      <div className="jal-copyright">
        <p>Copyright {new Date().getFullYear()} Jal RO System. All Rights Reserved.</p>
      </div>
    </div>
  </footer>
);

export const FloatingActions = () => (
  <div className="jal-floating-actions">
    <a className="jal-float-call" href={business.phoneHref} aria-label="Call Jal RO System">
      <i className="fas fa-phone-alt" />
    </a>
    <a className="jal-float-whatsapp" href={business.whatsapp} aria-label="WhatsApp Jal RO System">
      <i className="fab fa-whatsapp" />
    </a>
  </div>
);

const JalRoLayout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
    <FloatingActions />
    <EnquiryPopup />
  </>
);

export default JalRoLayout;
